(function () {
  const SIZES = [
    { label: '12 x 7', price: 35 },
    { label: '18 x 8', price: 55 },
    { label: '20 x 10', price: 75 },
    { label: '25 x 10', price: 95 },
    { label: '30 x 12', price: 140 },
    { label: '36 x 12', price: 165 },
    { label: '45 x 18', price: 300 },
  ];

  const SHAPES = [{"key":"board","label":"Board","points":[[0.01702,0.91393],[0.01734,0.9918],[0.01963,0.99786],[0.02234,0.99994],[0.14752,0.98672],[0.17018,0.98006],[0.18419,0.97739],[0.19365,0.97669],[0.20085,0.9769],[0.21057,0.97838],[0.22123,0.98034],[0.2385,0.98327],[0.25045,0.98641],[0.25235,0.98727],[0.25546,0.99204],[0.26163,0.9966],[0.26638,0.99773],[0.27279,0.99738],[0.28236,0.99471],[0.29395,0.99055],[0.30162,0.98909],[0.31114,0.98729],[0.33105,0.98184],[0.36511,0.97115],[0.38162,0.96701],[0.39413,0.9651],[0.40294,0.96477],[0.41263,0.96582],[0.423,0.96827],[0.43943,0.97371],[0.4674,0.98401],[0.48358,0.98858],[0.49712,0.99065],[0.53211,0.99465],[0.55966,0.99698],[0.59759,0.9991],[0.63623,1],[0.66525,0.99982],[0.70342,0.99837],[0.73128,0.9963],[0.76683,0.99217],[0.78806,0.98852],[0.79468,0.98638],[0.81048,0.97939],[0.83293,0.96898],[0.83931,0.96675],[0.84739,0.96498],[0.85301,0.96477],[0.85862,0.9657],[0.86788,0.96913],[0.8777,0.97425],[0.89744,0.98592],[0.99358,1.00001],[0.99738,0.99787],[0.99969,0.99167],[0.99997,0.98442],[0.99931,0.97054],[0.99833,0.95991],[0.99542,0.93816],[0.99027,0.90835],[0.98326,0.87077],[0.97844,0.84163],[0.97592,0.82104],[0.97515,0.81136],[0.97472,0.79927],[0.97488,0.79091],[0.97578,0.78077],[0.97743,0.772],[0.97869,0.77007],[0.9843,0.76354],[0.98764,0.75823],[0.98973,0.75251],[0.99341,0.73536],[0.9962,0.7171],[0.99871,0.69125],[0.99989,0.66435],[0.99994,0.64389],[0.99892,0.61683],[0.99736,0.59708],[0.99422,0.57203],[0.98984,0.54897],[0.98845,0.54445],[0.98465,0.53722],[0.97974,0.53058],[0.97769,0.52724],[0.97582,0.51866],[0.97428,0.50987],[0.97257,0.49747],[0.97069,0.47749],[0.96958,0.45601],[0.96922,0.42533],[0.9697,0.40104],[0.97119,0.36726],[0.9735,0.33228],[0.97644,0.29649],[0.98346,0.22405],[0.99072,0.15295],[0.99608,0.09411],[0.9983,0.06264],[0.99942,0.0403],[1,0.01258],[0.99933,0.00688],[0.99669,0.00158],[0.99233,0.00029],[0.9874,0.00087],[0.97711,0.00378],[0.96287,0.01042],[0.95216,0.01676],[0.93847,0.02606],[0.91626,0.04287],[0.90669,0.04509],[0.88858,0.02718],[0.87947,0.01953],[0.87019,0.01293],[0.86306,0.00876],[0.85325,0.00437],[0.84304,0.00143],[0.83502,0.00026],[0.82992,0.00057],[0.82204,0.00331],[0.81394,0.00806],[0.80284,0.01641],[0.78613,0.0305],[0.77284,0.04092],[0.76329,0.04656],[0.75907,0.04809],[0.75536,0.04863],[0.75063,0.04813],[0.74036,0.04763],[0.73253,0.04864],[0.72762,0.05012],[0.71514,0.05502],[0.70659,0.05729],[0.69792,0.05863],[0.68232,0.0596],[0.67265,0.05933],[0.65879,0.05689],[0.64319,0.05239],[0.63288,0.04798],[0.62782,0.04487],[0.62424,0.0417],[0.61648,0.03635],[0.60841,0.03325],[0.60221,0.03218],[0.59379,0.03217],[0.58738,0.03305],[0.57222,0.03732],[0.55043,0.04645],[0.53333,0.05396],[0.51704,0.05956],[0.50941,0.06106],[0.50394,0.06145],[0.49707,0.06084],[0.48991,0.05868],[0.47855,0.05307],[0.46691,0.04544],[0.4492,0.03211],[0.43159,0.01932],[0.4229,0.01413],[0.41148,0.00941],[0.40309,0.00817],[0.39265,0.00753],[0.36157,0.00337],[0.34389,0.00173],[0.33639,0.00188],[0.32819,0.00386],[0.32537,0.00573],[0.32158,0.01133],[0.31988,0.02222],[0.32083,0.0303],[0.32457,0.04488],[0.32849,0.05558],[0.33263,0.06458],[0.3377,0.07357],[0.34216,0.08008],[0.34785,0.08644],[0.35289,0.0893],[0.36414,0.09376],[0.3646,0.09772],[0.3603,0.10188],[0.35446,0.1061],[0.34848,0.10894],[0.34388,0.11024],[0.33758,0.11096],[0.33274,0.11078],[0.32615,0.10971],[0.31241,0.10505],[0.30176,0.09988],[0.27969,0.08725],[0.26456,0.07871],[0.23396,0.06302],[0.20295,0.04837],[0.17958,0.03824],[0.14848,0.02616],[0.1177,0.016],[0.09499,0.00983],[0.06541,0.00383],[0.0439,0.00117],[0.02214,0.0004],[0.01881,0.00379],[0.01733,0.00857],[0.01756,0.04883],[0.01913,0.10814],[0.01838,0.18557],[0.01445,0.21725],[0.0107,0.23195],[0.00692,0.25112],[0.00065,0.34639],[0.00066,0.42248],[0.00755,0.494],[0.0107,0.50221],[0.01551,0.51295],[0.0198,0.5586],[0.01666,0.62617],[0.01463,0.71416],[0.02145,0.74699],[0.03556,0.77193],[0.04472,0.79935],[0.04133,0.83436],[0.02711,0.8812]]},{"key":"rectangle","label":"Rectangle","points":[[0,1],[1,1],[1,0],[0,0],[0,1]]},{"key":"rounded","label":"Rounded","points":[[0.09258,0.92502],[0.11294,0.93308],[0.13129,0.94099],[0.148,0.94865],[0.16348,0.956],[0.17809,0.96297],[0.19222,0.96948],[0.20626,0.97545],[0.22059,0.98083],[0.2356,0.98553],[0.25166,0.98948],[0.27459,0.9933],[0.29876,0.99551],[0.32386,0.99641],[0.34958,0.99627],[0.37563,0.99537],[0.40168,0.994],[0.42745,0.99245],[0.45261,0.99099],[0.47688,0.9899],[0.49993,0.98948],[0.52298,0.98989],[0.54724,0.99094],[0.5724,0.99236],[0.59816,0.99387],[0.62422,0.99519],[0.65026,0.99606],[0.67598,0.9962],[0.70109,0.99533],[0.72526,0.99318],[0.7482,0.98948],[0.76735,0.98618],[0.78792,0.98341],[0.80944,0.98055],[0.83145,0.97699],[0.85349,0.97211],[0.8751,0.96528],[0.89582,0.9559],[0.9152,0.94336],[0.93276,0.92702],[0.94805,0.90628],[0.9539,0.8946],[0.95892,0.88065],[0.96322,0.86489],[0.96689,0.84773],[0.97003,0.82963],[0.97275,0.81101],[0.97514,0.79231],[0.9773,0.77397],[0.97934,0.75642],[0.98135,0.74011],[0.98397,0.71895],[0.98646,0.69654],[0.98878,0.67317],[0.99089,0.64915],[0.99273,0.62476],[0.99427,0.6003],[0.99546,0.57609],[0.99625,0.5524],[0.9966,0.52955],[0.99647,0.50783],[0.99581,0.48535],[0.99467,0.46223],[0.99309,0.43865],[0.99111,0.4148],[0.98878,0.39087],[0.98614,0.36705],[0.98322,0.34353],[0.98007,0.3205],[0.97673,0.29813],[0.97324,0.27664],[0.97063,0.25873],[0.96795,0.23687],[0.96509,0.21231],[0.96193,0.18632],[0.95835,0.16015],[0.95423,0.13505],[0.94944,0.11229],[0.94387,0.09312],[0.93739,0.0788],[0.92989,0.07059],[0.87413,0.04585],[0.80516,0.02751],[0.72693,0.01488],[0.64339,0.00723],[0.55849,0.00385],[0.47616,0.00404],[0.40037,0.00707],[0.33506,0.01225],[0.28417,0.01886],[0.25166,0.02618],[0.23364,0.03274],[0.21466,0.04064],[0.19504,0.04991],[0.1751,0.06057],[0.15516,0.07265],[0.13554,0.08617],[0.11656,0.10118],[0.09854,0.11768],[0.08179,0.13571],[0.06664,0.15529],[0.06143,0.16342],[0.05626,0.17276],[0.05119,0.1831],[0.04628,0.19425],[0.04159,0.206],[0.03717,0.21817],[0.03306,0.23055],[0.02934,0.24295],[0.02605,0.25516],[0.02325,0.267],[0.0191,0.28813],[0.01551,0.31088],[0.01245,0.33489],[0.00988,0.35979],[0.00778,0.38523],[0.00612,0.41084],[0.00489,0.43627],[0.00403,0.46115],[0.00354,0.48512],[0.00339,0.50783],[0.00361,0.53048],[0.00428,0.55433],[0.00536,0.57903],[0.00685,0.60428],[0.00873,0.62973],[0.01097,0.65506],[0.01356,0.67994],[0.01648,0.70406],[0.01972,0.72707],[0.02325,0.74865],[0.02669,0.76608],[0.03133,0.78617],[0.03701,0.80793],[0.04357,0.83039],[0.05085,0.85257],[0.0587,0.87349],[0.06696,0.89217],[0.07546,0.90764],[0.08405,0.91892],[0.09258,0.92502]]},{"key":"wavy","label":"Wavy","points":[[0.95453,0.19259],[0.9613,0.25103],[0.96884,0.31531],[0.9766,0.38337],[0.98402,0.45313],[0.99054,0.52251],[0.9956,0.58945],[0.99864,0.65188],[0.99911,0.70773],[0.99644,0.75492],[0.99007,0.79139],[0.98704,0.80185],[0.98385,0.81194],[0.98049,0.82168],[0.97697,0.83107],[0.9733,0.84011],[0.96947,0.8488],[0.9655,0.85717],[0.96139,0.86521],[0.95714,0.87292],[0.95276,0.88032],[0.94887,0.88897],[0.94571,0.90022],[0.94303,0.91325],[0.94054,0.92726],[0.93797,0.94144],[0.93507,0.95498],[0.93155,0.96706],[0.92715,0.97689],[0.9216,0.98365],[0.91463,0.98653],[0.90209,0.98514],[0.88808,0.97966],[0.87303,0.97115],[0.85737,0.96065],[0.84153,0.94922],[0.82593,0.93791],[0.81101,0.92778],[0.79718,0.91987],[0.78488,0.91525],[0.77454,0.91495],[0.7625,0.91961],[0.7524,0.92675],[0.74379,0.93564],[0.7362,0.94556],[0.72919,0.95579],[0.72228,0.96561],[0.71502,0.97428],[0.70695,0.9811],[0.69762,0.98532],[0.68655,0.98624],[0.67271,0.98502],[0.65935,0.98371],[0.64654,0.98241],[0.63434,0.98119],[0.62282,0.98014],[0.61204,0.97937],[0.60206,0.97895],[0.59295,0.97897],[0.58477,0.97953],[0.57759,0.98071],[0.57364,0.98154],[0.56764,0.98266],[0.55971,0.98401],[0.54998,0.98551],[0.53856,0.9871],[0.52558,0.9887],[0.51116,0.99024],[0.49541,0.99164],[0.47846,0.99285],[0.46044,0.99379],[0.4465,0.99252],[0.43198,0.98804],[0.41698,0.98107],[0.40155,0.97234],[0.38577,0.96256],[0.36972,0.95245],[0.35346,0.94274],[0.33706,0.93414],[0.32062,0.92738],[0.30418,0.92317],[0.2971,0.92347],[0.28976,0.92634],[0.28205,0.9313],[0.27389,0.93786],[0.26517,0.94556],[0.25581,0.95391],[0.24571,0.96243],[0.23477,0.97065],[0.22291,0.97808],[0.21002,0.98424],[0.19333,0.98987],[0.176,0.99384],[0.15848,0.99625],[0.14124,0.99719],[0.12475,0.99678],[0.10945,0.9951],[0.09583,0.99226],[0.08433,0.98835],[0.07543,0.98348],[0.06957,0.97775],[0.03872,0.90957],[0.01815,0.81717],[0.00619,0.70751],[0.00117,0.58753],[0.00141,0.4642],[0.00524,0.34447],[0.01098,0.23529],[0.01696,0.14361],[0.0215,0.07639],[0.02293,0.04059],[0.02907,0.02924],[0.04697,0.02477],[0.07408,0.02578],[0.10786,0.03086],[0.14575,0.03862],[0.18522,0.04766],[0.2237,0.05657],[0.25865,0.06397],[0.28752,0.06844],[0.30777,0.06859],[0.31909,0.06536],[0.33032,0.05981],[0.34148,0.05255],[0.35263,0.04419],[0.36378,0.03533],[0.37499,0.0266],[0.38628,0.01858],[0.39768,0.0119],[0.40924,0.00715],[0.42099,0.00495],[0.42929,0.00448],[0.43759,0.00406],[0.44589,0.0037],[0.45417,0.0034],[0.46244,0.00316],[0.47069,0.00298],[0.47892,0.00285],[0.48713,0.00279],[0.4953,0.00279],[0.50345,0.00285],[0.52063,0.00498],[0.53927,0.0105],[0.55895,0.01864],[0.57923,0.02865],[0.59968,0.03975],[0.61986,0.05119],[0.63935,0.06219],[0.65772,0.072],[0.67452,0.07985],[0.68933,0.08498],[0.7092,0.08879],[0.72631,0.08957],[0.74091,0.08775],[0.75329,0.08378],[0.76372,0.07812],[0.77246,0.07119],[0.7798,0.06345],[0.786,0.05535],[0.79134,0.04733],[0.79608,0.03983],[0.79968,0.03637],[0.80668,0.03187],[0.81654,0.02714],[0.8287,0.02294],[0.84261,0.02007],[0.85773,0.01933],[0.87351,0.02148],[0.8894,0.02734],[0.90485,0.03767],[0.91932,0.05327],[0.92463,0.06165],[0.92947,0.07175],[0.93386,0.08339],[0.93783,0.09638],[0.94142,0.11055],[0.94465,0.12571],[0.94755,0.14167],[0.95014,0.15826],[0.95246,0.1753],[0.95453,0.19259]]}];

  const FONTS = [
    { key: 'clean_block', label: 'Clean Block' },
    { key: 'classic_serif', label: 'Classic Serif' },
    { key: 'bold_condensed', label: 'Bold Condensed' },
    { key: 'rustic_slab', label: 'Rustic Slab' },
    { key: 'casual_script', label: 'Casual Script' },
    { key: 'elegant_script', label: 'Elegant Script' },
    { key: 'western', label: 'Western' },
    { key: 'playful_hand', label: 'Playful Hand' },
  ];

  const TEXT_EFFECTS = [
    { key: 'straight', label: 'Straight' },
    { key: 'arch_top', label: 'Arch Top' },
    { key: 'arch_bottom', label: 'Arch Bottom' },
  ];

  const PROOF_DISCLAIMER = 'Automated proofs are previews. CC Engravings may adjust artwork, spacing, text size, or layout before engraving so the finished sign cuts and engraves cleanly.';
  const PROOF_ENDPOINT_ATTRIBUTE = 'data-proof-endpoint';
  const FALLBACK_PROOF_ENDPOINT = 'https://cc-engravings-proof-service-i8rin.ondigitalocean.app';
  const STALE_PROOF_ENDPOINTS = new Set([
    'https://rent-spine-dec-departments.trycloudflare.com',
  ]);
  const UNITS_PER_INCH = 100;
  const MAX_TEXT_BOXES = 3;
  const MAX_UPLOAD_DIMENSION = 1600;
  const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
  const UPLOAD_JPEG_QUALITY = 0.86;
  const PROPERTY_NAMES = [
    'properties[_custom_sign_shape]',
    'properties[_custom_sign_size]',
    'properties[_custom_sign_text]',
    'properties[_custom_sign_fonts]',
    'properties[_custom_sign_artwork_source]',
    'properties[_custom_sign_artwork_prompt]',
    'properties[_custom_sign_preview_svg]',
    'properties[_custom_sign_proof_id]',
    'properties[_custom_sign_proof_vector]',
    'properties[_custom_sign_proof_dxf]',
    'properties[_custom_sign_text_boxes]',
    'properties[_custom_sign_artwork_geometry]',
    'properties[_custom_sign_proof_file]',
    'properties[_custom_sign_text_effects]',
  ];

  function parseSize(label) {
    const match = String(label).match(/^(\d+(?:\.\d+)?) x (\d+(?:\.\d+)?)$/);
    return { label, width: Number(match[1]), height: Number(match[2]) };
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function toUnits(value) {
    return Number((value * UNITS_PER_INCH).toFixed(2));
  }

  function textFitWidth(box) {
    return Math.max(1, Number((toUnits(box.width) * 0.995).toFixed(2)));
  }

  function textWidthFactor(fontKey) {
    const factors = {
      clean_block: 0.64,
      classic_serif: 0.58,
      bold_condensed: 0.54,
      rustic_slab: 0.62,
      casual_script: 0.5,
      elegant_script: 0.52,
      western: 0.6,
      playful_hand: 0.56,
    };
    return factors[fontKey] || factors.clean_block;
  }

  function measuredTextWidthAt100(text, fontKey) {
    const fallback = Math.max(1, text.length * textWidthFactor(fontKey) * 100);
    if (typeof document === 'undefined') return fallback;
    if (!measuredTextWidthAt100.canvas) {
      measuredTextWidthAt100.canvas = document.createElement('canvas');
    }
    const context = measuredTextWidthAt100.canvas.getContext('2d');
    if (!context) return fallback;
    context.font = `700 100px ${fontFamilyFor(fontKey)}`;
    const measured = context.measureText(text).width;
    return Number.isFinite(measured) && measured > 0 ? measured : fallback;
  }

  function normalizeTextEffect(effect) {
    return TEXT_EFFECTS.some((item) => item.key === effect) ? effect : 'straight';
  }

  function textArcPath(box) {
    const x = toUnits(box.x);
    const y = toUnits(box.y);
    const width = toUnits(box.width);
    const height = toUnits(box.height);
    const effect = normalizeTextEffect(box.textEffect);
    const baseY = y + height * (effect === 'arch_bottom' ? 0.24 : 0.78);
    const controlY = y + height * (effect === 'arch_bottom' ? 0.92 : 0.08);
    return `M ${x} ${Number(baseY.toFixed(2))} Q ${Number((x + width / 2).toFixed(2))} ${Number(controlY.toFixed(2))} ${Number((x + width).toFixed(2))} ${Number(baseY.toFixed(2))}`;
  }

  function textArcId(box) {
    const suffix = String(box.id || 'text')
      .replace(/[^a-z0-9_-]+/gi, '-')
      .replace(/^-+|-+$/g, '') || 'text';
    return `cc-text-arc-${suffix}`;
  }

  function renderTextPreview(box, fontSize, textX, textY) {
    const effect = normalizeTextEffect(box.textEffect);
    const style = `font-family:${fontFamilyFor(box.fontKey)}`;
    if (effect === 'straight') {
      return `<text class="copy" style="${style}" x="${textX}" y="${textY}" text-anchor="middle" dominant-baseline="middle" font-size="${fontSize}" data-font-key="${escapeHtml(box.fontKey)}" data-text-effect="${effect}">${escapeHtml(box.text)}</text>`;
    }
    const arcId = textArcId(box);
    return [
      `<path id="${arcId}" class="text-arc-path" d="${textArcPath(box)}"></path>`,
      `<text class="copy" style="${style}" text-anchor="middle" font-size="${fontSize}" data-font-key="${escapeHtml(box.fontKey)}" data-text-effect="${effect}">`,
      `<textPath href="#${arcId}" startOffset="50%">${escapeHtml(box.text)}</textPath>`,
      '</text>',
    ].join('');
  }

  function textFitFontSize(box) {
    const text = String(box.text || 'Your Text Here').replace(/\s+/g, ' ').trim();
    const heightSize = toUnits(box.height) * 0.9;
    const widthSize = (textFitWidth(box) / measuredTextWidthAt100(text, box.fontKey)) * 100;
    return Math.max(18, Math.min(heightSize, widthSize));
  }

  function editorControlScale(size) {
    return Math.max(1, Math.min(size.width / 12, size.height / 7));
  }

  function clampEditorControlX(centerX, totalWidth, size) {
    return clamp(centerX - totalWidth / 2, 0, Math.max(0, toUnits(size.width) - totalWidth));
  }

  function fromUnits(value) {
    return Number((value / UNITS_PER_INCH).toFixed(2));
  }

  function roundGeometry(value) {
    return Number(value.toFixed(2));
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function safeZones(size) {
    const textMarginX = size.width * 0.04;
    const textMarginY = size.height * 0.04;
    const artworkMarginX = size.width * 0.02;
    const artworkMarginY = size.height * 0.02;
    const text = {
      x: textMarginX,
      y: textMarginY,
      width: size.width - textMarginX * 2,
      height: size.height - textMarginY * 2,
    };
    const artwork = {
      x: artworkMarginX,
      y: artworkMarginY,
      width: size.width - artworkMarginX * 2,
      height: size.height - artworkMarginY * 2,
    };
    return {
      text: text,
      artwork: artwork,
      full: artwork,
    };
  }

  function shapePoints(shape, size) {
    return shape.points.map(([x, y]) => `${toUnits(x * size.width)},${toUnits(y * size.height)}`).join(' ');
  }

  function defaultTextBox(size, index) {
    const zone = safeZones(size).text;
    const height = zone.height * 0.24;
    const gap = zone.height * 0.06;
    const y = zone.y + zone.height * 0.14 + (height + gap) * index;
    return {
      id: `line-${index + 1}`,
      text: index === 0 ? 'Your Text Here' : '',
      fontKey: 'clean_block',
      textEffect: 'straight',
      x: roundGeometry(zone.x + zone.width * 0.08),
      y: roundGeometry(Math.min(y, zone.y + zone.height - height)),
      width: roundGeometry(zone.width * 0.84),
      height: roundGeometry(height),
    };
  }

  function defaultFullArtworkGeometry(size) {
    const zone = safeZones(size).artwork;
    return {
      x: roundGeometry(zone.x + zone.width * 0.16),
      y: roundGeometry(zone.y + zone.height * 0.08),
      width: roundGeometry(zone.width * 0.68),
      height: roundGeometry(zone.height * 0.82),
    };
  }

  function defaultLowerArtworkGeometry(size) {
    const zone = safeZones(size).artwork;
    return {
      x: roundGeometry(zone.x + zone.width * 0.08),
      y: roundGeometry(zone.y + zone.height * 0.52),
      width: roundGeometry(zone.width * 0.84),
      height: roundGeometry(zone.height * 0.42),
    };
  }

  function defaultArtworkGeometry(size, prompt = '') {
    // Default generated art stays in the lower half of the sign so editable text has clean space above.
    return hasExplicitUpperArtworkPlacement(prompt)
      ? defaultFullArtworkGeometry(size)
      : defaultLowerArtworkGeometry(size);
  }

  function geometryMatches(first, second) {
    return ['x', 'y', 'width', 'height'].every((key) => (
      Math.abs(Number(first && first[key]) - Number(second && second[key])) < 0.05
    ));
  }

  function clampBox(box, bounds) {
    const minWidth = Math.min(1.2, bounds.width);
    const minHeight = Math.min(0.5, bounds.height);
    const width = roundGeometry(clamp(box.width, minWidth, bounds.width));
    const height = roundGeometry(clamp(box.height, minHeight, bounds.height));
    return {
      ...box,
      width,
      height,
      x: roundGeometry(clamp(box.x, bounds.x, bounds.x + bounds.width - width)),
      y: roundGeometry(clamp(box.y, bounds.y, bounds.y + bounds.height - height)),
    };
  }

  function clampBoxToSign(box, bounds) {
    return clampBox(box, bounds);
  }

  function clampArtwork(artworkGeometry, size) {
    return clampBoxToSign(artworkGeometry, safeZones(size).artwork);
  }

  function proportionalResizeGeometry(start, dx, dy) {
    const ratio = start.width / Math.max(start.height, 0.01);
    if (!Number.isFinite(ratio) || ratio <= 0) {
      return { ...start, width: start.width + dx, height: start.height + dy };
    }
    if (Math.abs(dx) >= Math.abs(dy)) {
      const width = start.width + dx;
      return { ...start, width, height: width / ratio };
    }
    const height = start.height + dy;
    return { ...start, width: height * ratio, height };
  }

  function artworkPath(geometry) {
    const x = toUnits(geometry.x);
    const y = toUnits(geometry.y);
    const width = toUnits(geometry.width);
    const height = toUnits(geometry.height);
    return [
      `M ${x} ${y + height}`,
      `L ${x + width * 0.2} ${y + height * 0.42}`,
      `L ${x + width * 0.34} ${y + height}`,
      `L ${x + width * 0.52} ${y + height * 0.12}`,
      `L ${x + width * 0.8} ${y + height}`,
      'Z',
    ].join(' ');
  }

  function hasGeneratedArtwork(proof) {
    return Boolean(proof && proof.design && proof.design.artwork && proof.design.artwork.svgPath);
  }

  function artworkPreserveAspectRatio(artwork) {
    return 'xMidYMax meet';
  }

  function generatedArtworkMarkup(proof, geometry) {
    if (!hasGeneratedArtwork(proof)) return '';
    const artwork = proof.design.artwork;
    const box = geometry || artwork;
    const path = artwork.displaySvgPath || artwork.svgPath;
    return `<svg class="generated-artwork" x="${toUnits(box.x)}" y="${toUnits(box.y)}" width="${toUnits(box.width)}" height="${toUnits(box.height)}" viewBox="${escapeHtml(artwork.sourceViewBox || '0 0 100 100')}" preserveAspectRatio="${artworkPreserveAspectRatio(artwork)}"><path class="silhouette-art" d="${escapeHtml(path)}"></path></svg>`;
  }

  function assetReference(asset) {
    if (!asset) return '';
    return asset.url || asset.id || '';
  }

  function fontFamilyFor(fontKey) {
    const fonts = {
      clean_block: 'Arial, Helvetica, sans-serif',
      classic_serif: 'Georgia, Times New Roman, serif',
      bold_condensed: 'Impact, Arial Narrow, sans-serif',
      rustic_slab: 'Rockwell, Georgia, serif',
      casual_script: 'Brush Script MT, Segoe Script, cursive',
      elegant_script: 'Palatino Linotype, Georgia, serif',
      western: 'Copperplate, Rockwell, serif',
      playful_hand: 'Comic Sans MS, Segoe Print, cursive',
    };
    return fonts[fontKey] || fonts.clean_block;
  }

  function normalizeProofEndpoint(endpoint) {
    const normalized = String(endpoint || '').replace(/\/$/, '');
    return STALE_PROOF_ENDPOINTS.has(normalized) ? FALLBACK_PROOF_ENDPOINT : normalized;
  }

  function extractQuotedTextSuggestions(prompt) {
    return Array.from(String(prompt || '').matchAll(/"([^"]{1,80})"/g))
      .map((match) => match[1].replace(/\s+/g, ' ').trim())
      .filter(Boolean)
      .slice(0, MAX_TEXT_BOXES);
  }

  function cleanArtworkPromptForAi(prompt) {
    return String(prompt || '')
      .replace(/"[^"]{1,80}"/g, ' ')
      .replace(/\b(at the top|on top|across the top|below that|under that|at the bottom|arched|arch|curve|curved|in script|script font|with text|with wording|saying|that says)\b/gi, ' ')
      .replace(/\s+[,.;:]\s+/g, ', ')
      .replace(/\s+/g, ' ')
      .replace(/\s+,/g, ',')
      .replace(/,\s*(and\s*)?$/i, '')
      .trim();
  }

  function stripTextPlacementNoise(value) {
    return String(value || '')
      .replace(/"[^"]{1,120}"/g, ' ')
      .replace(/\b(?:arch|arched|curved|script|cursive|lettering|letters?|text|words?|quote|says?|est\.?|established|family name|last name|name)\b/gi, ' ');
  }

  function hasExplicitUpperArtworkPlacement(value) {
    const prompt = stripTextPlacementNoise(value);
    const artworkNoun = '(?:sun|moon|clouds?|stars?|sky|birds?|seagulls?|eagles?|fireworks?|rainbow|mountains?|treetops?|trees?|palm\\s+trees?)';
    return [
      new RegExp(`\\b${artworkNoun}\\b[^.]{0,80}\\b(?:at|near|toward|on|in)\\s+(?:the\\s+)?(?:top|upper|sky|top half|upper half)\\b`, 'i'),
      new RegExp(`\\b(?:at|near|toward|on|in)\\s+(?:the\\s+)?(?:top|upper|sky|top half|upper half)\\b[^.]{0,80}\\b${artworkNoun}\\b`, 'i'),
      new RegExp(`\\b${artworkNoun}\\b[^.]{0,80}\\b(?:above|overhead)\\b`, 'i'),
    ].some((pattern) => pattern.test(prompt));
  }

  function suggestedTextEffect(prompt, index) {
    if (index === 0 && /\b(arch|arched|curved|across the top|at the top|on top)\b/i.test(prompt || '')) {
      return 'arch_top';
    }
    if (/\b(bottom|below|under)\b/i.test(prompt || '') && index > 0) {
      return 'straight';
    }
    return 'straight';
  }

  class CustomSignBuilder extends HTMLElement {
    connectedCallback() {
      const size = parseSize(this.dataset.defaultSize || '12 x 7');
      this.proofEndpoint = normalizeProofEndpoint(
        this.getAttribute(PROOF_ENDPOINT_ATTRIBUTE) || this.dataset.proofEndpoint || '',
      );
      this.dragState = null;
      this.state = {
        shape: this.dataset.defaultShape || 'rectangle',
        size: size.label,
        textBoxes: [defaultTextBox(size, 0)],
        activeElement: { type: 'text', id: 'line-1' },
        editingTextId: null,
        artworkMode: 'idea',
        artworkPrompt: '',
        artworkVisible: true,
        artworkGeometry: defaultArtworkGeometry(size),
        artworkBox: defaultArtworkGeometry(size),
        upload: null,
        proof: null,
        proofStatus: 'idle',
        proofMessage: '',
        generatedPreviewSvg: '',
      };
      this.render();
      this.sync({ controls: true });
    }

    render() {
      this.innerHTML = `
        <section class="cc-builder" aria-label="Fully custom silhouette sign builder">
          <style>
            .cc-builder{position:relative;display:grid;gap:18px;margin:18px 0;padding:18px;border:1px solid rgba(36,24,15,.18);background:#fbf7f0;width:100%}
            .cc-builder__workspace{display:grid;grid-template-columns:1fr;gap:18px;align-items:start}
            .cc-builder__controls{display:grid;grid-template-columns:repeat(12,minmax(0,1fr));gap:14px;align-items:start}
            .cc-builder__panel{display:grid;gap:12px;padding:14px;border:1px solid rgba(36,24,15,.14);background:#fff;border-radius:6px}
            .cc-builder__product-options{grid-column:1/-1;display:grid;grid-template-columns:repeat(4,minmax(160px,1fr));gap:12px;align-items:end}
            .cc-builder__artwork{grid-column:1/-1}
            .cc-builder__status,.cc-builder__note{grid-column:1/-1}
            .cc-builder label{display:grid;gap:6px;font-size:14px;font-weight:700;color:#24180f}
            .cc-builder select,.cc-builder textarea,.cc-builder input[type="file"]{width:100%;border:1px solid rgba(36,24,15,.24);border-radius:6px;padding:11px 12px;background:#fff;font:inherit;color:#24180f}
            .cc-builder textarea{resize:vertical}
            .cc-builder button{width:max-content;border:0;border-radius:6px;padding:11px 16px;background:#24180f;color:#fff;font:inherit;font-weight:700;cursor:pointer}
            .cc-builder button[disabled]{opacity:.58;cursor:not-allowed}
            .cc-builder__preview-shell{display:grid;gap:10px}
            .cc-builder__preview-actions{display:flex;justify-content:flex-end;gap:10px;align-items:center}
            .cc-builder__preview{display:grid;align-items:center;min-height:280px;padding:18px;background:#f6efe4;border:1px solid rgba(36,24,15,.16);touch-action:none}
            .cc-builder__preview svg{display:block;width:100%;height:auto;max-height:560px}
            .cc-builder__overlay{position:absolute;inset:0;z-index:40;display:grid;place-items:center;padding:24px;background:rgba(251,247,240,.82);backdrop-filter:blur(2px);pointer-events:auto}
            .cc-builder__overlay[hidden]{display:none}
            .cc-builder__overlay-message{max-width:360px;padding:16px 18px;border:1px solid rgba(36,24,15,.2);border-radius:6px;background:#fff;color:#24180f;font-weight:800;text-align:center;box-shadow:0 12px 32px rgba(36,24,15,.18)}
            .cc-builder__artwork-actions{display:flex;gap:10px;align-items:center;flex-wrap:wrap}
            .cc-builder__note{margin:0;font-size:13px;line-height:1.45;color:#5a4a39}
            .cc-builder__status{min-height:20px;margin:0;font-size:13px;line-height:1.45;color:#5a4a39}
            .cc-builder__status[data-state="error"]{color:#9f1d1d}
            .cc-builder__status[data-state="success"]{color:#1f6b38}
            .cc-editor-target{cursor:move}
            .cc-editor-box{fill:rgba(255,255,255,.04);stroke:rgba(36,24,15,.42);stroke-width:6}
            .cc-editor-box[data-active="true"]{stroke:#b34700;stroke-dasharray:none}
            .cc-editor-handle{fill:#fff;stroke:#24180f;stroke-width:5;cursor:nwse-resize}
            .cc-editor-button rect{fill:#24180f;stroke:#fff;stroke-width:3;rx:8;cursor:pointer}
            .cc-editor-button text{fill:#fff;font-family:Arial,Helvetica,sans-serif;font-size:30px;font-weight:700;pointer-events:none}
            .cc-editor-trash rect{fill:#8f1d16}
            .cc-svg-button{width:100%;height:100%;border:2px solid #fff;border-radius:8px;background:#24180f;color:#fff;font:700 20px Arial,Helvetica,sans-serif;cursor:pointer;padding:0}
            .cc-svg-button--trash{background:#8f1d16;font-size:26px}
            .cc-svg-button--delete{background:#8f1d16;font-size:26px}
            .cc-svg-select{width:100%;height:100%;box-sizing:border-box;border:2px solid #fff;border-radius:8px;background:#24180f;color:#fff;font:700 18px Arial,Helvetica,sans-serif;padding:0 10px;cursor:pointer}
            .cc-inline-text-editor{display:block;width:100%;height:100%;box-sizing:border-box;border:2px solid #24180f;border-radius:4px;background:rgba(255,255,255,.82);color:#050505;text-align:center;overflow:hidden;resize:none;line-height:1.05;padding:0 1px}
            @media (max-width: 989px){.cc-builder__controls{grid-template-columns:1fr}.cc-builder__product-options,.cc-builder__artwork{grid-column:auto}.cc-builder__product-options{grid-template-columns:repeat(2,minmax(0,1fr))}}
            @media (max-width: 749px){.cc-builder{padding:16px;margin:16px 0}.cc-builder__product-options{grid-template-columns:1fr}.cc-builder__preview{min-height:180px}}
          </style>
          <div class="cc-builder__workspace">
            <div class="cc-builder__preview-shell">
              <div class="cc-builder__preview-actions">
                <button type="button" data-preview-text-add>+ Text</button>
              </div>
              <div class="cc-builder__preview" data-preview></div>
            </div>
            <div class="cc-builder__controls">
              <div class="cc-builder__panel cc-builder__product-options">
                <label>Shape
                  <select data-field="shape">
                    ${SHAPES.map((shape) => `<option value="${shape.key}">${shape.label}</option>`).join('')}
                  </select>
                </label>
                <label>Size
                  <select data-field="size">
                    ${SIZES.map((size) => `<option value="${size.label}">${size.label} - $${size.price}</option>`).join('')}
                  </select>
                </label>
              </div>
              <div class="cc-builder__panel cc-builder__artwork">
                <label>Generate artwork from idea
                  <textarea data-field="artworkPrompt" rows="3" placeholder='Example: palm trees on the left, sunset over the ocean, seagulls on the right, arched "The Swishers" and "est. 2026" below'></textarea>
                </label>
                <label>Upload photo
                  <input data-field="upload" type="file" accept="image/*">
                </label>
                <div class="cc-builder__artwork-actions">
                  <button type="button" data-proof-generate>Generate Preview</button>
                </div>
                <p class="cc-builder__status" data-proof-status aria-live="polite"></p>
              </div>
              <p class="cc-builder__note">${PROOF_DISCLAIMER}</p>
            </div>
            <div data-properties></div>
          </div>
          <div class="cc-builder__overlay" data-proof-overlay hidden aria-live="assertive" aria-busy="true">
            <div class="cc-builder__overlay-message">Please wait while we prepare your artwork. This usually takes about 30 seconds.</div>
          </div>
        </section>
      `;

      this.querySelector('[data-field="shape"]').value = this.state.shape;
      this.querySelector('[data-field="size"]').value = this.state.size;
      this.querySelector('[data-field="artworkPrompt"]').value = this.state.artworkPrompt;

      this.addEventListener('input', (event) => this.handleInput(event));
      this.addEventListener('change', (event) => this.handleChange(event));
      this.addEventListener('click', (event) => this.handleClick(event));
      this.addEventListener('focusout', (event) => this.handleFocusOut(event));
      this.addEventListener('keydown', (event) => this.handleKeyDown(event));
      this.addEventListener('pointerdown', (event) => this.handlePointerDown(event));
      this.addEventListener('pointermove', (event) => this.handlePointerMove(event));
      this.addEventListener('pointerup', (event) => this.handlePointerUp(event));
      this.addEventListener('pointercancel', (event) => this.handlePointerUp(event));
    }

    handleFieldInput(target) {
      const field = target && target.dataset && target.dataset.field;
      if (field && field !== 'upload') {
        if (this.state[field] === target.value) return true;
        const previousSize = parseSize(this.state.size);
        this.state[field] = target.value;
        if (field === 'size') {
          this.scaleGeometryToNewSize(previousSize, parseSize(this.state.size));
        }
        if (field === 'shape' || field === 'size') {
          this.syncNativeVariantSelection(field, target.value);
          this.sync({ controls: false });
          if (field === 'size') {
            this.autoRefreshAiProofAfterSizeChange();
          }
          return true;
        }
        this.resetProof();
        this.sync({ controls: false });
        return true;
      }
      return false;
    }

    handleInput(event) {
      const target = event.target;
      if (target && target.dataset && target.dataset.inlineTextEditor) {
        this.updateInlineTextBox(target.dataset.inlineTextEditor, target.value);
        return;
      }

      if (this.handleFieldInput(target)) return;
    }

    handleChange(event) {
      let target = event.target;
      target = target && target.closest
        ? target.closest('[data-field],[data-preview-text-font],[data-preview-text-effect],[data-artwork-center],[data-artwork-remove],[data-proof-generate],[data-text-select]') || target
        : target;
      if (!target || !target.dataset) return;

      if (this.handleFieldInput(target)) return;

      if (target.dataset.field === 'upload') {
        this.readSelectedUpload(target);
        return;
      }

      if (target.dataset.previewTextFont) {
        this.updateTextBox(target.dataset.previewTextFont, { fontKey: target.value });
        this.syncTextControls();
      }
      if (target.dataset.previewTextEffect) {
        this.updateTextBox(target.dataset.previewTextEffect, { textEffect: target.value });
        this.syncTextControls();
      }
    }

    handleClick(event) {
      const target = event.target;
      if (!target || !target.dataset) return;

      if (target.dataset.previewTextAdd !== undefined) {
        this.addTextBox({ editInline: true });
      }
      if (target.dataset.previewTextRemove) {
        this.removeTextBox(target.dataset.previewTextRemove);
      }
      if (target.dataset.textCenter) {
        this.centerTextBox(target.dataset.textCenter);
      }
      if (target.dataset.artworkCenter !== undefined) {
        this.centerArtwork();
      }
      if (target.dataset.artworkRemove !== undefined) {
        this.removeArtwork();
      }
      if (target.dataset.proofGenerate !== undefined) {
        this.generateProof();
      }
      if (target.dataset.textSelect) {
        this.setActiveElement('text', target.dataset.textSelect);
      }
    }

    handleFocusOut(event) {
      if (event.target && event.target.dataset && event.target.dataset.inlineTextEditor) {
        this.endInlineTextEdit();
      }
    }

    handleKeyDown(event) {
      if (!event.target || !event.target.dataset || !event.target.dataset.inlineTextEditor) return;
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        event.target.blur();
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.endInlineTextEdit();
      }
    }

    async readSelectedUpload(input) {
      this.setProofStatus('loading', 'Reading uploaded photo...');
      try {
        this.state.upload = await this.prepareUploadForProof(input.files && input.files[0]);
        if (this.state.upload) {
          this.state.artworkMode = 'upload';
          this.state.artworkVisible = true;
          this.state.activeElement = { type: 'artwork', id: 'artwork' };
          this.resetProof();
          this.sync({ controls: false });
          await this.generateProof();
          return;
        }
        this.resetProof();
        this.sync({ controls: false });
      } catch (error) {
        this.state.upload = null;
        this.resetProof();
        this.sync({ controls: false });
        this.setProofStatus('error', error.message || 'Unable to read uploaded photo.');
      }
    }

    resetProof() {
      this.state.proof = null;
      this.state.generatedPreviewSvg = '';
    }

    preserveProofOnTextEdit() {
      if (this.state.proof) {
        this.setProofStatus('idle', 'Artwork kept. Click Generate Preview again if you want the downloadable proof updated with the latest text.');
      }
    }

    setActiveElement(type, id) {
      this.state.activeElement = { type, id };
      if (type !== 'text') {
        this.state.editingTextId = null;
      }
      this.sync({ controls: false });
    }

    beginInlineTextEdit(id) {
      this.state.activeElement = { type: 'text', id };
      this.state.editingTextId = id;
      this.sync({ controls: false });
      window.setTimeout(() => {
        const editor = this.querySelector(`[data-inline-text-editor="${id}"]`);
        if (editor) {
          editor.focus();
          editor.select();
        }
      }, 0);
    }

    endInlineTextEdit() {
      if (!this.state.editingTextId) return;
      this.state.editingTextId = null;
      this.sync({ controls: true });
    }

    activeTextBox() {
      if (!this.state.activeElement || this.state.activeElement.type !== 'text') return null;
      return this.state.textBoxes.find((box) => box.id === this.state.activeElement.id) || null;
    }

    textBoxesCanBeAutoFilled() {
      return this.state.textBoxes.length === 0 || this.state.textBoxes.every((box) => {
        const text = String(box.text || '').trim();
        return text === '' || text === 'Your Text Here';
      });
    }

    applyPromptTextSuggestions() {
      const prompt = this.state.artworkPrompt || '';
      const suggestions = extractQuotedTextSuggestions(prompt);
      if (suggestions.length === 0) return false;

      const cleanedPrompt = cleanArtworkPromptForAi(prompt);
      if (cleanedPrompt && cleanedPrompt !== this.state.artworkPrompt) {
        this.state.artworkPrompt = cleanedPrompt;
        const promptField = this.querySelector('[data-field="artworkPrompt"]');
        if (promptField) promptField.value = cleanedPrompt;
      }

      if (!this.textBoxesCanBeAutoFilled()) {
        this.syncPropertiesOnly();
        return true;
      }

      const size = parseSize(this.state.size);
      const textBounds = safeZones(size).text;
      this.state.textBoxes = suggestions.map((text, index) => {
        const box = defaultTextBox(size, index);
        return clampBox({
          ...box,
          text,
          fontKey: index === 0 && /\b(script|cursive)\b/i.test(prompt) ? 'elegant_script' : 'classic_serif',
          textEffect: suggestedTextEffect(prompt, index),
        }, textBounds);
      });
      this.state.activeElement = this.state.textBoxes[0]
        ? { type: 'text', id: this.state.textBoxes[0].id }
        : this.state.activeElement;
      this.state.editingTextId = null;
      this.sync({ controls: true });
      return true;
    }

    artworkGeometryCanBeAutoPlaced(size) {
      return (
        geometryMatches(this.state.artworkGeometry, defaultLowerArtworkGeometry(size)) ||
        geometryMatches(this.state.artworkGeometry, defaultFullArtworkGeometry(size))
      );
    }

    applyPromptArtworkLayoutSuggestion(prompt) {
      const size = parseSize(this.state.size);
      if (!this.artworkGeometryCanBeAutoPlaced(size)) return false;
      this.setArtworkGeometry(defaultArtworkGeometry(size, prompt));
      return true;
    }

    addTextBox({ editInline = false } = {}) {
      if (this.state.textBoxes.length >= MAX_TEXT_BOXES) return;
      const size = parseSize(this.state.size);
      const box = defaultTextBox(size, this.state.textBoxes.length);
      this.state.textBoxes = [...this.state.textBoxes, box];
      this.state.activeElement = { type: 'text', id: box.id };
      this.preserveProofOnTextEdit();
      this.sync({ controls: true });
      if (editInline) {
        this.beginInlineTextEdit(box.id);
      }
    }

    removeTextBox(id) {
      this.state.textBoxes = this.state.textBoxes.filter((box) => box.id !== id);
      if (!this.activeTextBox()) {
        const next = this.state.textBoxes[0];
        this.state.activeElement = next
          ? { type: 'text', id: next.id }
          : (this.state.artworkVisible ? { type: 'artwork', id: 'artwork' } : null);
      }
      this.preserveProofOnTextEdit();
      this.sync({ controls: true });
    }

    updateTextBox(id, updates) {
      const size = parseSize(this.state.size);
      const textBounds = safeZones(size).text;
      const normalizedUpdates = updates.textEffect
        ? { ...updates, textEffect: normalizeTextEffect(updates.textEffect) }
        : updates;
      this.state.textBoxes = this.state.textBoxes.map((box) => (
        box.id === id ? clampBox({ ...box, ...normalizedUpdates }, textBounds) : box
      ));
      this.state.activeElement = { type: 'text', id };
      this.preserveProofOnTextEdit();
      this.sync({ controls: false });
    }

    updateInlineTextBox(id, text) {
      const size = parseSize(this.state.size);
      const textBounds = safeZones(size).text;
      this.state.textBoxes = this.state.textBoxes.map((box) => (
        box.id === id ? clampBox({ ...box, text }, textBounds) : box
      ));
      this.state.activeElement = { type: 'text', id };
      this.preserveProofOnTextEdit();
      this.syncTextControls();
      this.syncPropertiesOnly();
    }

    centerTextBox(id) {
      const bounds = safeZones(parseSize(this.state.size)).text;
      this.state.textBoxes = this.state.textBoxes.map((box) => (
        box.id === id
          ? clampBox({
            ...box,
            x: bounds.x + (bounds.width - box.width) / 2,
          }, bounds)
          : box
      ));
      this.state.activeElement = { type: 'text', id };
      this.preserveProofOnTextEdit();
      this.sync({ controls: false });
    }

    centerArtwork() {
      const bounds = safeZones(parseSize(this.state.size)).artwork;
      const artwork = this.state.artworkGeometry;
      this.setArtworkGeometry(clampArtwork({
        ...artwork,
        x: bounds.x + (bounds.width - artwork.width) / 2,
      }, parseSize(this.state.size)));
      this.state.activeElement = { type: 'artwork', id: 'artwork' };
      this.sync({ controls: false });
    }

    removeArtwork() {
      this.state.upload = null;
      this.state.proof = null;
      this.state.artworkVisible = false;
      this.state.generatedPreviewSvg = '';
      this.state.activeElement = this.state.textBoxes[0]
        ? { type: 'text', id: this.state.textBoxes[0].id }
        : null;
      this.setProofStatus('idle', 'Artwork removed. Upload a new photo or generate a new idea.');
      this.sync({ controls: false });
    }

    syncNativeVariantSelection(field, value) {
      const productInfo = this.closest('product-info') || document;
      const optionName = field === 'shape' ? 'Shape' : 'Size';
      const desiredLabel = field === 'shape'
        ? (SHAPES.find((shape) => shape.key === value)?.label || value)
        : value;
      const select = productInfo.querySelector(`variant-selects select[name="options[${optionName}]"]`);
      if (!select) return;
      const option = Array.from(select.options).find((candidate) => (
        candidate.textContent.trim().toLowerCase() === desiredLabel.trim().toLowerCase()
        || candidate.value.trim().toLowerCase() === desiredLabel.trim().toLowerCase()
      ));
      if (!option || select.value === option.value) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    clampGeometryToCurrentSize() {
      const size = parseSize(this.state.size);
      const zones = safeZones(size);
      this.state.textBoxes = this.state.textBoxes.map((box) => clampBox(box, zones.text));
      this.setArtworkGeometry(clampArtwork(this.state.artworkGeometry, size));
    }

    scaleGeometryToNewSize(previousSize, nextSize) {
      if (!previousSize || !nextSize || previousSize.width <= 0 || previousSize.height <= 0) {
        this.clampGeometryToCurrentSize();
        return;
      }
      const scaleX = nextSize.width / previousSize.width;
      const scaleY = nextSize.height / previousSize.height;
      const zones = safeZones(nextSize);
      this.state.textBoxes = this.state.textBoxes.map((box) => clampBox({
        ...box,
        x: roundGeometry(box.x * scaleX),
        y: roundGeometry(box.y * scaleY),
        width: roundGeometry(box.width * scaleX),
        height: roundGeometry(box.height * scaleY),
      }, zones.text));
      this.setArtworkGeometry(clampArtwork({
        ...this.state.artworkGeometry,
        x: roundGeometry(this.state.artworkGeometry.x * scaleX),
        y: roundGeometry(this.state.artworkGeometry.y * scaleY),
        width: roundGeometry(this.state.artworkGeometry.width * scaleX),
        height: roundGeometry(this.state.artworkGeometry.height * scaleY),
      }, nextSize));
    }

    pointerToInches(event) {
      const svg = this.querySelector('[data-preview] svg');
      if (!svg) return null;
      const point = svg.createSVGPoint();
      point.x = event.clientX;
      point.y = event.clientY;
      const transformed = point.matrixTransform(svg.getScreenCTM().inverse());
      return { x: fromUnits(transformed.x), y: fromUnits(transformed.y) };
    }

    handlePointerDown(event) {
      if (event.target.closest && event.target.closest('[data-inline-text-editor]')) return;
      const handle = event.target.closest('[data-resize-handle],[data-artwork-handle]');
      const target = event.target.closest('[data-editor-target]');
      if (!handle && !target) return;

      const point = this.pointerToInches(event);
      if (!point) return;

      const textId = (handle && handle.dataset.resizeHandle) || (target && target.dataset.textTarget);
      const artworkTarget = (handle && handle.dataset.artworkHandle !== undefined) || (target && target.dataset.artworkTarget !== undefined);
      if (textId) {
        const box = this.state.textBoxes.find((item) => item.id === textId);
        if (!box) return;
        this.state.activeElement = { type: 'text', id: textId };
        if (handle) {
          this.startResize('text', textId, point, box);
        } else {
          this.startDrag('text', textId, point, box);
        }
      } else if (artworkTarget) {
        this.state.activeElement = { type: 'artwork', id: 'artwork' };
        if (handle) {
          this.startResize('artwork', 'artwork', point, this.state.artworkGeometry);
        } else {
          this.startDrag('artwork', 'artwork', point, this.state.artworkGeometry);
        }
      }

      event.target.setPointerCapture(event.pointerId);
      event.preventDefault();
      this.sync({ controls: false });
    }

    startDrag(targetType, id, startPoint, startGeometry) {
      this.dragState = {
        type: `move-${targetType}`,
        id,
        startPoint,
        startGeometry: { ...startGeometry },
        moved: false,
      };
    }

    startResize(targetType, id, startPoint, startGeometry) {
      this.dragState = {
        type: `resize-${targetType}`,
        id,
        startPoint,
        startGeometry: { ...startGeometry },
        moved: false,
      };
    }

    handlePointerMove(event) {
      if (!this.dragState) return;
      const point = this.pointerToInches(event);
      if (!point) return;

      const dx = point.x - this.dragState.startPoint.x;
      const dy = point.y - this.dragState.startPoint.y;
      if (Math.abs(dx) > 0.05 || Math.abs(dy) > 0.05) {
        this.dragState.moved = true;
      }
      const start = this.dragState.startGeometry;
      const size = parseSize(this.state.size);

      if (this.dragState.type === 'move-text') {
        this.updateTextBoxGeometry(this.dragState.id, { ...start, x: start.x + dx, y: start.y + dy });
      } else if (this.dragState.type === 'resize-text') {
        this.updateTextBoxGeometry(this.dragState.id, proportionalResizeGeometry(start, dx, dy));
      } else if (this.dragState.type === 'move-artwork') {
        this.setArtworkGeometry(clampArtwork({ ...start, x: start.x + dx, y: start.y + dy }, size));
        this.sync({ controls: false });
      } else if (this.dragState.type === 'resize-artwork') {
        this.setArtworkGeometry(clampArtwork({ ...start, width: start.width + dx, height: start.height + dy }, size));
        this.sync({ controls: false });
      }
    }

    setArtworkGeometry(artworkGeometry) {
      this.state.artworkGeometry = artworkGeometry;
      this.state.artworkBox = artworkGeometry;
    }

    handlePointerUp(event) {
      if (!this.dragState) return;
      const shouldEditText = this.dragState.type === 'move-text' && !this.dragState.moved;
      const editTextId = this.dragState.id;
      if (event.target.releasePointerCapture) {
        try {
          event.target.releasePointerCapture(event.pointerId);
        } catch (error) {
          // The pointer may already be released by the browser.
        }
      }
      this.dragState = null;
      if (shouldEditText) {
        this.beginInlineTextEdit(editTextId);
      }
    }

    updateTextBoxGeometry(id, geometry) {
      const bounds = safeZones(parseSize(this.state.size)).text;
      this.state.textBoxes = this.state.textBoxes.map((box) => (
        box.id === id ? clampBox({ ...box, ...geometry }, bounds) : box
      ));
      this.preserveProofOnTextEdit();
      this.sync({ controls: false });
    }

    fontOptions(selectedFont) {
      return FONTS.map((font) => `<option value="${font.key}"${font.key === selectedFont ? ' selected' : ''}>${font.label}</option>`).join('');
    }

    textEffectOptions(selectedEffect) {
      const normalized = normalizeTextEffect(selectedEffect);
      return TEXT_EFFECTS.map((effect) => `<option value="${effect.key}"${effect.key === normalized ? ' selected' : ''}>${effect.label}</option>`).join('');
    }

    syncTextControls() {
      const previewAddButton = this.querySelector('[data-preview-text-add]');
      if (previewAddButton) {
        previewAddButton.disabled = this.state.textBoxes.length >= MAX_TEXT_BOXES;
      }
    }

    buildSvg() {
      const size = parseSize(this.state.size);
      const shape = SHAPES.find((item) => item.key === this.state.shape) || SHAPES[0];
      const zones = safeZones(size);
      const prompt = this.state.artworkPrompt.trim();
      const artworkTitle = prompt ? `AI artwork idea: ${prompt}` : 'Silhouette artwork preview placeholder';
      const active = this.state.activeElement || {};
      const artworkActive = this.state.artworkVisible && active.type === 'artwork';
      const points = shapePoints(shape, size);
      const clipId = `cc-sign-clip-${this.state.shape}`;
      const controlScale = editorControlScale(size);
      const centerButtonWidth = 124 * controlScale;
      const effectSelectWidth = 154 * controlScale;
      const fontSelectWidth = 184 * controlScale;
      const deleteButtonWidth = 48 * controlScale;
      const controlHeight = 42 * controlScale;
      const controlGap = 10 * controlScale;
      const handleSize = 44 * controlScale;
      const textControlGroupWidth = centerButtonWidth + effectSelectWidth + fontSelectWidth + deleteButtonWidth + controlGap * 3;
      const artworkControlGroupWidth = centerButtonWidth + deleteButtonWidth + controlGap;

      const textGroups = this.state.textBoxes.map((box) => {
        const textX = toUnits(box.x + box.width / 2);
        const textY = toUnits(box.y + box.height / 2);
        const fontSize = textFitFontSize(box);
        const boxActive = active.type === 'text' && active.id === box.id;
        const isEditing = this.state.editingTextId === box.id;
        const actionX = clampEditorControlX(toUnits(box.x + box.width / 2), textControlGroupWidth, size);
        const buttonY = Math.max(0, toUnits(box.y) - controlHeight - controlGap);
        const effectX = actionX + centerButtonWidth + controlGap;
        const fontX = effectX + effectSelectWidth + controlGap;
        const deleteX = fontX + fontSelectWidth + controlGap;
        const previewFontOptions = this.fontOptions(box.fontKey);
        const previewTextEffectOptions = this.textEffectOptions(box.textEffect);
        const inlineEditor = isEditing ? `
          <foreignObject x="${toUnits(box.x)}" y="${toUnits(box.y)}" width="${toUnits(box.width)}" height="${toUnits(box.height)}">
            <textarea xmlns="http://www.w3.org/1999/xhtml" class="cc-inline-text-editor" data-inline-text-editor="${box.id}" style="font-family:${fontFamilyFor(box.fontKey)};font-size:${fontSize}px">${escapeHtml(box.text)}</textarea>
          </foreignObject>
        ` : '';
        const targetMarkup = `
          <g class="cc-editor-target" data-editor-target data-text-target="${box.id}" data-text-box-id="${box.id}">
            <rect class="cc-editor-box" data-active="${boxActive}" x="${toUnits(box.x)}" y="${toUnits(box.y)}" width="${toUnits(box.width)}" height="${toUnits(box.height)}"></rect>
            ${isEditing ? '' : renderTextPreview(box, fontSize, textX, textY)}
            ${inlineEditor}
          </g>
        `;
        const controlMarkup = boxActive ? `
          <rect class="cc-editor-handle" data-resize-handle="${box.id}" x="${toUnits(box.x + box.width) - handleSize / 2}" y="${toUnits(box.y + box.height) - handleSize / 2}" width="${handleSize}" height="${handleSize}"></rect>
          <foreignObject class="cc-editor-button" x="${actionX}" y="${buttonY}" width="${centerButtonWidth}" height="${controlHeight}">
            <button xmlns="http://www.w3.org/1999/xhtml" class="cc-svg-button" style="font-size:${20 * controlScale}px" type="button" data-text-center="${box.id}">Center</button>
          </foreignObject>
          <foreignObject class="cc-editor-button" x="${effectX}" y="${buttonY}" width="${effectSelectWidth}" height="${controlHeight}">
            <select xmlns="http://www.w3.org/1999/xhtml" class="cc-svg-select" style="font-size:${18 * controlScale}px" data-preview-text-effect="${box.id}" aria-label="Style">${previewTextEffectOptions}</select>
          </foreignObject>
          <foreignObject class="cc-editor-button" x="${fontX}" y="${buttonY}" width="${fontSelectWidth}" height="${controlHeight}">
            <select xmlns="http://www.w3.org/1999/xhtml" class="cc-svg-select" style="font-size:${18 * controlScale}px" data-preview-text-font="${box.id}" aria-label="Font">${previewFontOptions}</select>
          </foreignObject>
          <foreignObject class="cc-editor-button cc-editor-trash" x="${deleteX}" y="${buttonY}" width="${deleteButtonWidth}" height="${controlHeight}">
            <button xmlns="http://www.w3.org/1999/xhtml" class="cc-svg-button cc-svg-button--delete" style="font-size:${26 * controlScale}px" type="button" data-preview-text-remove="${box.id}">x</button>
          </foreignObject>
        ` : '';
        return { targetMarkup, controlMarkup };
      });
      const textMarkup = textGroups.map((group) => group.targetMarkup).join('');
      const activeTextControlMarkup = textGroups.map((group) => group.controlMarkup).join('');

      const artwork = this.state.artworkGeometry;
      const artworkHandle = artworkActive
        ? `<rect class="cc-editor-handle" data-artwork-handle x="${toUnits(artwork.x + artwork.width) - handleSize / 2}" y="${toUnits(artwork.y + artwork.height) - handleSize / 2}" width="${handleSize}" height="${handleSize}"></rect>`
        : '';
      const generatedArtwork = generatedArtworkMarkup(this.state.proof, artwork);
      const artworkBody = generatedArtwork || `<text class="artwork-empty" x="${toUnits(artwork.x + artwork.width / 2)}" y="${toUnits(artwork.y + artwork.height / 2)}" text-anchor="middle" dominant-baseline="middle">Generate or upload artwork</text>`;
      const artworkMarkup = this.state.artworkVisible ? `<g class="cc-editor-target" data-editor-target data-artwork-target data-proof-layer="artwork" clip-path="url(#${clipId})">
            <rect class="cc-editor-box" data-active="${artworkActive}" x="${toUnits(artwork.x)}" y="${toUnits(artwork.y)}" width="${toUnits(artwork.width)}" height="${toUnits(artwork.height)}"></rect>
            ${artworkBody}
            <title>${escapeHtml(artworkTitle)}</title>
          </g>` : '';
      const artworkCenterX = clampEditorControlX(toUnits(artwork.x + artwork.width / 2), artworkControlGroupWidth, size);
      const artworkCenterY = Math.max(0, toUnits(artwork.y) - controlHeight - controlGap);
      const artworkTrashX = artworkCenterX + centerButtonWidth + controlGap;
      const artworkTrashY = artworkCenterY;
      const activeArtworkControlMarkup = this.state.artworkVisible && artworkActive ? `
        ${artworkHandle}
        <g class="cc-artwork-actions" data-artwork-actions>
          <foreignObject class="cc-editor-button" x="${artworkCenterX}" y="${artworkCenterY}" width="${centerButtonWidth}" height="${controlHeight}">
            <button xmlns="http://www.w3.org/1999/xhtml" class="cc-svg-button" style="font-size:${20 * controlScale}px" type="button" data-artwork-center>Center</button>
          </foreignObject>
          <foreignObject class="cc-editor-button cc-editor-trash" x="${artworkTrashX}" y="${artworkTrashY}" width="${deleteButtonWidth}" height="${controlHeight}">
            <button xmlns="http://www.w3.org/1999/xhtml" class="cc-svg-button cc-svg-button--trash" style="font-size:${26 * controlScale}px" type="button" data-artwork-remove>x</button>
          </foreignObject>
        </g>
      ` : '';
      const activeControlMarkup = `
        <g class="cc-active-controls" data-active-controls>
          ${activeTextControlMarkup}
          ${activeArtworkControlMarkup}
        </g>
      `;

      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${toUnits(size.width)} ${toUnits(size.height)}" preserveAspectRatio="xMidYMid meet" role="img">
          <defs>
            <clipPath id="${clipId}">
              <polygon points="${points}"></polygon>
            </clipPath>
            <filter id="cc-wood-noise" x="-8%" y="-8%" width="116%" height="116%">
              <feTurbulence type="fractalNoise" baseFrequency="0.018 0.13" numOctaves="4" seed="17" result="grainNoise"></feTurbulence>
              <feColorMatrix in="grainNoise" type="matrix" values="0.45 0 0 0 0.12 0 0.34 0 0 0.07 0 0 0.16 0 0.02 0 0 0 0.34 0" result="grainColor"></feColorMatrix>
              <feBlend in="SourceGraphic" in2="grainColor" mode="multiply"></feBlend>
            </filter>
            <linearGradient id="cc-wood-tone" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0" stop-color="#c9823d"></stop>
              <stop offset="0.18" stop-color="#efad61"></stop>
              <stop offset="0.36" stop-color="#ce853d"></stop>
              <stop offset="0.58" stop-color="#f2b76b"></stop>
              <stop offset="0.78" stop-color="#b76f32"></stop>
              <stop offset="1" stop-color="#e4a058"></stop>
            </linearGradient>
            <linearGradient id="cc-board-shading" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0" stop-color="#5b341b" stop-opacity="0.18"></stop>
              <stop offset="0.08" stop-color="#ffffff" stop-opacity="0.2"></stop>
              <stop offset="0.5" stop-color="#5b341b" stop-opacity="0.06"></stop>
              <stop offset="0.92" stop-color="#ffffff" stop-opacity="0.16"></stop>
              <stop offset="1" stop-color="#3b2414" stop-opacity="0.22"></stop>
            </linearGradient>
            <pattern id="cc-wood-grain" width="420" height="150" patternUnits="userSpaceOnUse">
              <rect class="wood-pattern-base" width="420" height="150"></rect>
              <rect class="wood-plank" x="0" y="0" width="70" height="150"></rect>
              <rect class="wood-plank" x="70" y="0" width="70" height="150"></rect>
              <rect class="wood-plank" x="140" y="0" width="70" height="150"></rect>
              <rect class="wood-plank" x="210" y="0" width="70" height="150"></rect>
              <rect class="wood-plank" x="280" y="0" width="70" height="150"></rect>
              <rect class="wood-plank" x="350" y="0" width="70" height="150"></rect>
              <path class="wood-grain" d="M -16 22 C 34 12, 68 33, 116 21 S 194 15, 238 28 S 318 34, 438 18 M -14 48 C 38 35, 92 63, 138 48 S 214 38, 264 52 S 335 63, 438 45 M -12 78 C 46 62, 84 89, 142 75 S 230 65, 278 82 S 340 94, 438 76 M -14 112 C 42 96, 92 124, 150 108 S 236 100, 292 114 S 354 132, 438 109"></path>
              <path class="wood-dark-grain" d="M -8 35 C 28 28, 54 45, 86 38 S 146 22, 194 37 S 268 58, 330 42 S 386 28, 430 39 M -8 94 C 30 78, 72 99, 116 90 S 168 75, 210 88 S 264 112, 320 96 S 374 78, 430 91"></path>
              <ellipse class="wood-knot" cx="108" cy="82" rx="34" ry="13"></ellipse>
              <ellipse class="wood-knot-line" cx="108" cy="82" rx="20" ry="7"></ellipse>
              <ellipse class="wood-knot" cx="302" cy="42" rx="27" ry="10"></ellipse>
              <ellipse class="wood-knot-line" cx="302" cy="42" rx="15" ry="5"></ellipse>
            </pattern>
          </defs>
          <style>
            .wood-pattern-base{fill:url(#cc-wood-tone)}
            .sign-wood{fill:url(#cc-wood-grain)}
            .wood-plank{fill:url(#cc-board-shading);opacity:.6}
            .wood-grain{fill:none;stroke:#7b4a25;stroke-width:4;opacity:.38}
            .wood-dark-grain{fill:none;stroke:#4d2c17;stroke-width:7;opacity:.25}
            .wood-knot{fill:none;stroke:#75451f;stroke-width:5;opacity:.32}
            .wood-knot-line{fill:none;stroke:#3f2515;stroke-width:3;opacity:.24}
            .sign-border{fill:none;stroke:#24180f;stroke-width:10}
            .silhouette-art{fill:#050505}
            .artwork-empty{fill:#6d5a44;font-family:sans-serif;font-size:34px;opacity:.72;pointer-events:none}
            .copy{fill:#111;font-weight:700;pointer-events:none}
            .text-arc-path{fill:none;stroke:none}
          </style>
          <rect class="sign-wood" clip-path="url(#${clipId})" filter="url(#cc-wood-noise)" x="0" y="0" width="${toUnits(size.width)}" height="${toUnits(size.height)}"></rect>
          ${artworkMarkup}
          ${textMarkup}
          <polygon class="sign-border" data-proof-layer="border-last" points="${points}"></polygon>
          <!-- Border drawn last so the proof keeps a clean carved edge. -->
          ${activeControlMarkup}
        </svg>
      `;
    }

    serializedTextBoxes() {
      return this.state.textBoxes.map((box) => ({
        id: box.id,
        text: box.text,
        fontKey: box.fontKey,
        textEffect: normalizeTextEffect(box.textEffect),
        x: box.x,
        y: box.y,
        width: box.width,
        height: box.height,
      }));
    }

    lineItemProperties(svg) {
      const textBoxes = this.serializedTextBoxes();
      const properties = {
        'properties[Custom sign shape]': this.state.shape,
        'properties[Custom sign size]': this.state.size,
        'properties[Custom sign text]': this.state.textBoxes.map((box) => box.text).join('\n'),
        'properties[Custom sign text layout]': this.state.textBoxes.map((box) => normalizeTextEffect(box.textEffect)).join(', '),
        'properties[Custom sign artwork source]': this.state.upload ? 'uploaded_photo' : (this.state.artworkPrompt.trim() ? 'ai_prompt' : 'pending'),
        'properties[Custom sign artwork prompt]': this.state.artworkPrompt,
        [PROPERTY_NAMES[0]]: this.state.shape,
        [PROPERTY_NAMES[1]]: this.state.size,
        [PROPERTY_NAMES[2]]: this.state.textBoxes.map((box) => box.text).join('\n'),
        [PROPERTY_NAMES[3]]: this.state.textBoxes.map((box) => box.fontKey).join(', '),
        [PROPERTY_NAMES[4]]: this.state.upload ? 'uploaded_photo' : (this.state.artworkPrompt.trim() ? 'ai_prompt' : 'pending'),
        [PROPERTY_NAMES[5]]: this.state.artworkPrompt,
        [PROPERTY_NAMES[6]]: svg.replace(/\s+/g, ' ').trim(),
        [PROPERTY_NAMES[10]]: JSON.stringify(this.state.textBoxes.map((box) => ({
          id: box.id,
          text: box.text,
          fontKey: box.fontKey,
          textEffect: normalizeTextEffect(box.textEffect),
          x: box.x,
          y: box.y,
          width: box.width,
          height: box.height,
        }))),
        [PROPERTY_NAMES[11]]: JSON.stringify(this.state.artworkGeometry),
        [PROPERTY_NAMES[13]]: this.state.textBoxes.map((box) => normalizeTextEffect(box.textEffect)).join(', '),
      };
      if (this.state.proof && this.state.proof.id) {
        properties['properties[Custom sign proof ID]'] = this.state.proof.id;
        properties[PROPERTY_NAMES[7]] = this.state.proof.id;
      }
      if (this.state.proof && this.state.proof.assets && this.state.proof.assets.proof) {
        properties['properties[Custom sign proof file]'] = assetReference(this.state.proof.assets.proof);
        properties[PROPERTY_NAMES[12]] = assetReference(this.state.proof.assets.proof);
      }
      if (this.state.proof && this.state.proof.assets && this.state.proof.assets.vector) {
        properties['properties[Custom sign proof vector]'] = assetReference(this.state.proof.assets.vector);
        properties[PROPERTY_NAMES[8]] = assetReference(this.state.proof.assets.vector);
      }
      if (this.state.proof && this.state.proof.assets && this.state.proof.assets.dxf) {
        properties['properties[Custom sign proof DXF]'] = assetReference(this.state.proof.assets.dxf);
        properties[PROPERTY_NAMES[9]] = assetReference(this.state.proof.assets.dxf);
      }
      return properties;
    }

    sync({ controls = false } = {}) {
      if (controls) {
        this.syncTextControls();
      }
      const svg = this.state.generatedPreviewSvg || this.buildSvg();
      this.querySelector('[data-preview]').innerHTML = svg;
      this.syncProofStatus();
      const properties = this.lineItemProperties(svg);
      this.querySelector('[data-properties]').innerHTML = Object.entries(properties)
        .map(([name, value]) => `<input type="hidden" name="${name}" value="${escapeHtml(value)}">`)
        .join('');
      this.syncFormProperties(properties);
    }

    syncPropertiesOnly() {
      const svg = this.state.generatedPreviewSvg || this.buildSvg();
      const properties = this.lineItemProperties(svg);
      this.querySelector('[data-properties]').innerHTML = Object.entries(properties)
        .map(([name, value]) => `<input type="hidden" name="${name}" value="${escapeHtml(value)}">`)
        .join('');
      this.syncFormProperties(properties);
    }

    syncProofStatus() {
      const status = this.querySelector('[data-proof-status]');
      const button = this.querySelector('[data-proof-generate]');
      const overlay = this.querySelector('[data-proof-overlay]');
      if (!status || !button || !overlay) return;
      status.dataset.state = this.state.proofStatus;
      status.textContent = this.state.proofMessage;
      button.disabled = this.state.proofStatus === 'loading';
      overlay.hidden = this.state.proofStatus !== 'loading';
    }

    setProofStatus(proofStatus, proofMessage) {
      this.state.proofStatus = proofStatus;
      this.state.proofMessage = proofMessage;
      this.syncProofStatus();
    }

    shouldAutoRefreshAiProofAfterSizeChange() {
      const proof = this.state.proof;
      if (this.state.upload || this.state.proofStatus === 'loading') return false;
      if (!proof || !proof.artwork || proof.artwork.source !== 'ai_prompt') return false;
      return Boolean(this.referenceArtworkForProof());
    }

    autoRefreshAiProofAfterSizeChange() {
      if (!this.shouldAutoRefreshAiProofAfterSizeChange()) return false;
      this.generateProof();
      return true;
    }

    referenceArtworkForProof() {
      const proof = this.state.proof;
      if (!proof || !proof.artwork || proof.artwork.source !== 'ai_prompt') return null;
      if (proof.artwork.prompt && proof.artwork.prompt !== this.state.artworkPrompt) return null;
      if (!proof.assets || !proof.assets.sourceImage) return null;
      const sourceImageUrl = assetReference(proof.assets.sourceImage);
      if (!sourceImageUrl) return null;
      return {
        source: 'ai_prompt',
        sourceImageUrl: sourceImageUrl,
        mimeType: proof.sourceImage && proof.sourceImage.mimeType || 'image/png',
        model: proof.sourceImage && proof.sourceImage.model || '',
        proofId: proof.id || '',
        sizeLabel: proof.design && proof.design.size && proof.design.size.label || '',
        shapeKey: proof.design && proof.design.shape && proof.design.shape.key || '',
      };
    }

    buildProofPayload() {
      const textBoxes = this.serializedTextBoxes();

      const payload = {
        shapeKey: this.state.shape,
        sizeLabel: this.state.size,
        artworkPrompt: this.state.artworkPrompt,
        artworkGeometry: this.state.artworkGeometry,
        textBoxes: this.state.textBoxes.map((box) => ({
          id: box.id,
          text: box.text,
          fontKey: box.fontKey,
          textEffect: normalizeTextEffect(box.textEffect),
          x: box.x,
          y: box.y,
          width: box.width,
          height: box.height,
        })),
      };
      const referenceArtwork = this.referenceArtworkForProof();
      if (referenceArtwork) {
        payload.referenceArtwork = referenceArtwork;
      }
      return payload;
    }

    proofUrl(path) {
      const endpoint = this.proofEndpoint.replace(/\/$/, '');
      if (endpoint.endsWith('/apps/custom-sign') && path.startsWith('/custom-sign/')) {
        return `${endpoint}${path.replace('/custom-sign', '')}`;
      }
      return `${endpoint}${path}`;
    }

    async readUpload(file) {
      if (!file) return null;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('Unable to read uploaded photo.'));
        reader.onload = () => {
          const result = String(reader.result || '');
          resolve({
            base64: result.split(',').pop(),
            mimeType: file.type || 'application/octet-stream',
            name: file.name || 'upload',
          });
        };
        reader.readAsDataURL(file);
      });
    }

    async prepareUploadForProof(file) {
      if (!file) return null;
      const isImage = /^image\//i.test(file.type || '');
      if (!isImage || !file.size || file.size <= MAX_UPLOAD_BYTES) {
        return this.readUpload(file);
      }
      if (typeof URL === 'undefined' || typeof Image === 'undefined' || typeof document === 'undefined') {
        throw new Error('Uploaded photo is too large. Please choose a smaller image and try again.');
      }

      const objectUrl = URL.createObjectURL(file);
      try {
        const image = await new Promise((resolve, reject) => {
          const element = new Image();
          element.onload = () => resolve(element);
          element.onerror = () => reject(new Error('Unable to prepare uploaded photo.'));
          element.src = objectUrl;
        });
        const sourceWidth = image.naturalWidth || image.width;
        const sourceHeight = image.naturalHeight || image.height;
        if (!sourceWidth || !sourceHeight) {
          throw new Error('Unable to prepare uploaded photo.');
        }
        const scale = Math.min(1, MAX_UPLOAD_DIMENSION / Math.max(sourceWidth, sourceHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(sourceWidth * scale));
        canvas.height = Math.max(1, Math.round(sourceHeight * scale));
        const context = canvas.getContext('2d');
        if (!context) {
          throw new Error('Unable to prepare uploaded photo.');
        }
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const blob = await new Promise((resolve, reject) => {
          canvas.toBlob((preparedBlob) => {
            if (preparedBlob) {
              resolve(preparedBlob);
            } else {
              reject(new Error('Unable to prepare uploaded photo.'));
            }
          }, 'image/jpeg', UPLOAD_JPEG_QUALITY);
        });
        if (blob.size > MAX_UPLOAD_BYTES) {
          throw new Error('Uploaded photo is too large. Please choose a smaller image and try again.');
        }
        const preparedName = `${(file.name || 'upload').replace(/\.[^.]+$/, '')}.jpg`;
        const preparedFile = new File([blob], preparedName, { type: 'image/jpeg' });
        return await this.readUpload(preparedFile);
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
    }

    async readProofResponse(response) {
      const text = await response.text();
      const contentType = response.headers && response.headers.get
        ? String(response.headers.get('content-type') || '')
        : '';
      let result = {};
      if (text) {
        try {
          result = JSON.parse(text);
        } catch (error) {
          result = contentType.includes('text/')
            ? { error: text.replace(/\s+/g, ' ').trim().slice(0, 240) }
            : {};
        }
      }
      if (!response.ok) {
        const fallback = response.status === 413
          ? 'Uploaded photo is too large. Please choose a smaller image and try again.'
          : 'Unable to generate proof.';
        throw new Error(result.error || result.customerMessage || fallback);
      }
      return result;
    }

    async generateProof() {
      this.applyPromptTextSuggestions();
      const hasUpload = Boolean(this.state.upload);
      if (!hasUpload) {
        this.applyPromptArtworkLayoutSuggestion(this.state.artworkPrompt);
      }

      if (!this.proofEndpoint) {
        this.setProofStatus('idle', 'Proof service is not connected yet; your local preview and order details are saved.');
        return;
      }

      this.setProofStatus('loading', 'Generating proof...');
      try {
        const path = hasUpload ? '/custom-sign/proofs/from-upload' : '/custom-sign/proofs/from-prompt';
        const payload = this.buildProofPayload();
        if (hasUpload) {
          payload.upload = this.state.upload;
        }
        const response = await fetch(this.proofUrl(path), {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const result = await this.readProofResponse(response);
        if (result.status === 'rejected') {
          throw new Error(result.customerMessage || 'Unable to generate proof from that image.');
        }
        const proof = result.proof || {};
        const proofArtwork = proof.design && proof.design.artwork;
        if (proofArtwork) {
          this.setArtworkGeometry({
            x: proofArtwork.x,
            y: proofArtwork.y,
            width: proofArtwork.width,
            height: proofArtwork.height,
          });
        }
        this.state.proof = proof;
        this.state.artworkVisible = true;
        this.state.activeElement = { type: 'artwork', id: 'artwork' };
        this.state.generatedPreviewSvg = '';
        this.setProofStatus('success', 'Proof ready.');
        this.sync({ controls: false });
      } catch (error) {
        this.setProofStatus('error', `Unable to generate proof: ${error.message}`);
      }
    }

    syncFormProperties(properties) {
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
        .filter((form) => form.querySelector('input[name="id"]'));
      forms.forEach((form) => {
        form.querySelectorAll('[data-cc-custom-sign-property]').forEach((input) => input.remove());
        Object.entries(properties).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          input.setAttribute('data-cc-custom-sign-property', 'true');
          form.appendChild(input);
        });
      });
    }
  }

  if (!customElements.get('cc-custom-sign-builder')) {
    customElements.define('cc-custom-sign-builder', CustomSignBuilder);
  }
})();
